import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CallingScreenService } from '../_services/calling-screen.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { Subscription } from 'rxjs';
import { GameModeService } from '../game-mode/_services/game-mode.service';
import { AmplitudeService } from 'src/app/_services/amplitude.service';

declare var $: any;

@Component({
  selector: 'app-calling-screen',
  templateUrl: './calling-screen.component.html',
  styleUrls: ['./calling-screen.component.scss']
})

export class CallingScreenComponent implements OnInit {
  filteredData: any = [];
  currLang;
  loading = true;
  innerWidth;
  innerHeight;
  response: any = [];
  id: number;
  reload: boolean;
  classTotalWidth: number;
  refreshFlag: boolean = true;
  owlContainerWidth: number;
  customOptions: OwlOptions = {};
  studentContainer = true;
  classItem = { name: '', grade: {}, students: [], width: 0, col: 1 };
  soundsArray = [];
  logedInUserType = "";
  isCallingScreenGamification = false;
  tescherClassList: any = [];
  deliverFlag: boolean = false;
  studentsToDeliver: any = [];
  studentsToDeliverIds: any = [];
  baseuUlr = environment.img_url;
  noDeliverFlag: boolean = false;
  originalGrades: Array<any> = [];
  grades: Array<any> = [];
  allClasses: Array<any> = [];
  filteredClasses: Array<any> = [];
  filterArray: Array<any> = [];
  sections: Array<any> = [];
  gradeName = 'all';
  className = 'all';
  sectionName = 'all';
  gradeId: number;
  classId: number;
  sectionId: number;
  direction = 1;
  scrollWidth = 0;
  stopScroll = false;
  isScroll = false;
  wasScroll = false;
  interval;
  delegationInProgressFlag = false;
  userId;
  reqArray = [];
  totalRequests;
  filteredRequests;
  activeTab;
  recallSoundsArray = [];
  isRecall:boolean = false;
  recallCount = 0;
  reasonForNoDeliver;
  toggleRecallTipFlag = false;
  recallTip:string = "";
  realtimeSub$:any 
  showVoiceOnAlert:boolean = false;
  private callingScreenVisibilityChangeHandler: () => void;
  constructor(
    private router: Router,
    private callingScreen: CallingScreenService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private ref: ChangeDetectorRef,
    private errorMsgService: ErrorMsgService,
    private dataService: DataService,
    public gameModeService: GameModeService,
    private amplitudeService: AmplitudeService,
  ) {
    this.userId = localStorage.getItem("userId");
    this.callingScreen.getIsReconected().subscribe(res => {
      if (res == true) {
        this.initiatCallingScreen();
        this.callingScreen.setIsReconected(false);
        setInterval(() => {
          this.ref.detectChanges();
        }, 1000)
      }
    })
    let reloadFlag = localStorage.getItem("relaod");
    if (reloadFlag == 'true') {
      localStorage.setItem("relaod", 'false');
      window.location.reload();
    }
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.logedInUserType = localStorage.getItem('loginAs');
  }

  ngOnInit(): void {
    // Check if this is a beta school and redirect to beta calling screen
    this.dataService.getIsCallingScreenBeta().subscribe(isBeta => {
      if (isBeta) {
        this.router.navigate(['/calling-screen/calling-screen-beta']);
        return;
      }
    });

    this.dataService.getIsCallingScreenGamification().subscribe(res => {
      this.isCallingScreenGamification = res;
    });

    this.activeTab = window.location.pathname.split('/')[2];
    this.dataService.getAllSections().subscribe((res: any) => {
      if (res) {
        this.sections = res;
      }
    })

    this.callingScreen.subscribe(`delegation_request_user_${localStorage.getItem('userId')}` , `delegation.accepted` , data =>{
      if (data.status == 'accepted' && data.to_user_id == +this.userId) {
            this.delegationInProgressFlag = true;
            this.getClasses(true);
          }
          if (data.status == 'accepted' && data.from_user_id == +this.userId) {
            setTimeout(() => this.initiatCallingScreen(), 3000);
            this.getClasses(true);
        }
    })

    this.callingScreen.subscribe(`delegation_request_user_${localStorage.getItem('userId')}` , `App\\Events\\Delegation\\DelegationRequestCanceled` , data =>{
      this.delegationInProgressFlag = true;
      this.getClasses(true);
    })

    this.callingScreen.subscribe(`calling_screen_${localStorage.getItem('schoolId')}` , `App\\Events\\CallingScreen` , data =>{
      console.log('cs data',data);
      // if (this.delegationInProgressFlag == true) {
      //   this.reqArray.push(Object.assign({}, data));
      // } else {
        if(this.activeTab == 'calling-screen'){
        this.recallSoundsArray = [];
        this.requestProssesing(data);
        }
      // }
    })

    ///supervisor sound play
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.getClasses();


    // this.innerWidth = (window.innerWidth - 76);
    // this.innerHeight = window.innerHeight - 116;
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.reload = true;
    this.checkVisibilityChange();
    // this.animateRequests();
  }
  requestProssesing(data) {
    let enableVoiceCalling = localStorage.getItem('voiceCalling');
    let statusCalling = localStorage.getItem('statusCalling');
    let studentName = data.students[0].audio_file_path;
    
    let arabicStatus = data.students[0].request_status.status_file_url.ar;
    let englishStatus = data.students[0].request_status.status_file_url.en;
    let arabicLateStatus = data.students[0].request[0].status_file_url.ar;
    let englishLateStatus = data.students[0].request[0].status_file_url.en;
    let isLate = data.students[0].request[0].is_late;
    let deleted_at = data.students[0]?.request[0]?.deleted_at;
    let isDelivered = data.students[0]?.request_status?.name;

    let inTeacherClass = false;
    if (this.logedInUserType == "teacher" || this.logedInUserType == "supervisor") {
      let clazz = this.tescherClassList.find(cls => cls.id == data.students[0].class_id);
      if (clazz) {
        inTeacherClass = true;
      }
    } else {
      inTeacherClass = true;
    }
    // Notify game mode of dismissal if game is active
    if (this.gameModeService.isGameActive() && inTeacherClass) {
      this.gameModeService.triggerDismissalInterrupt({
        studentId: data.students[0].id,
        studentName: data.students[0].name || data.students[0].first_name || 'Student',
        studentImage: data.students[0].image_path || null,
        className: '',
        requestId: data.students[0].request?.[0]?.id || 0
      });
    }
    if (inTeacherClass) {
      let Clazz = this.filteredData.find(Clas => Clas.id == data.students[0].class_id);
      if (Clazz != undefined) {
        // findIndex returns the Index of student if exists or -1 if no student was found 
        let existingStudent = Clazz.students.findIndex(student => student.id == data.students[0].id);
        // check if student exists remove it then push it again from pusher data 
        if (existingStudent >= 0) {
          Clazz.students.splice(existingStudent, 1);
          Clazz.students.push(...data.students);
        }
        // if student doesn't exist push directly from pusher data 
        else {
          Clazz.students.push(...data.students);
        }
      }
      //  check if the student is not deleted push the class to the filteredData array
      else if (!deleted_at) {
        this.filteredData.push(data);
      }
    }

    if (enableVoiceCalling === 'true') {
      let inTeacherClass = false;
      if (this.logedInUserType == "teacher" || this.logedInUserType == "supervisor") {
        let clazz = this.tescherClassList.find(cls => cls.id == data.students[0].class_id);
        if (clazz) {
          inTeacherClass = true;
        }
      } else {
        inTeacherClass = true;
      }
      // Start with the section_id check
      let isStudentMatchFilter = this.sectionId ? data.section_id == this.sectionId : true;
      // Add the grade_id check
      isStudentMatchFilter = this.gradeId ? data.grade_id == this.gradeId && isStudentMatchFilter : isStudentMatchFilter;
      // Add the class_id check
      isStudentMatchFilter = this.classId ? data.students[0].class_id == this.classId && isStudentMatchFilter : isStudentMatchFilter;
      if (isDelivered != 'delivered' && isDelivered != 'with_parent') {

        if (!deleted_at && inTeacherClass && isStudentMatchFilter && studentName) {
          this.addSoundToPlay(studentName);
          switch (statusCalling) {

            case 'ar':
              if (isLate == 1) {
                this.addSoundToPlay(arabicLateStatus);

              }
              else {
                this.addSoundToPlay(arabicStatus);

              }
              break;
            case 'en':
              if (isLate == 1) {
                this.addSoundToPlay(englishLateStatus);

              }
              else {
                this.addSoundToPlay(englishStatus);

              }
              break;
          }
          if (this.soundsArray.length != 0) {
            this.playSound();


          }
        }
      }

    }
    // remove cancelled or delivered students or with_parent students
    if (deleted_at != null || isDelivered == 'delivered' || isDelivered == 'with_parent') {
      // get the index of the class that has the deleted students
      let Clazz = this.filteredData.findIndex(Clas => Clas.id == data.students[0].class_id);
      // return student id that not equal to the deleted student id , and replace the student in the class 
      this.filteredData[Clazz].students = this.filteredData[Clazz].students.filter(student => student.id != data.students[0].id);
      // check if the length of the students array in filtered data of this class equal zero , then remove the entire class
      this.filteredData = this.filteredData.filter(_Clazz => _Clazz.students.length != 0);

      this.filteringData();
      let Clazz2 = this.filterArray.findIndex(Clas => Clas.id == data.students[0].class_id);
      // return student id that not equal to the deleted student id , and replace the student in the class 
      if (Clazz2 != -1) {
        this.filterArray[Clazz2].students = this.filterArray[Clazz2].students.filter(student => student.id != data.students[0].id);
        // check if the length of the students array in filtered data of this class equal zero , then remove the entire class
        this.filterArray = this.filterArray.filter(_Clazz => _Clazz.students.length != 0);
      }
    }

    this.filteringData();
    // this.clearFilter();

    if (this.reqArray.length > 0) {
      this.reqArray.splice(0);
      this.requestProssesing(this.reqArray[0]);
    }

    // this.clearFilter();
  }
  getClasses(reload = false) {
    if (this.logedInUserType == "teacher") {
      this.callingScreen.getTeacherClasses(localStorage.getItem("userId"),localStorage.getItem("lastShcoolSelectedId")).subscribe((classes: any) => {
        this.tescherClassList = classes;
        this.delegationInProgressFlag = false;
        this.allClasses = classes;

        this.grades = classes.filter(e => e.grade).map(e => e.grade);
        this.grades = this.grades.filter(function (elem, index, self) {
          return index === self.findIndex(e => elem.id == e.id);
        });
        this.originalGrades = [];
        this.originalGrades = this.grades;
        this.filterSectionsBasedOnRoleGrades(this.originalGrades, this.sections);
        if (this.reload) {
          this.initiatCallingScreen();
        }
        // if (this.reqArray.length != 0) {
        //   this.requestProssesing(this.reqArray[0]);
        //   this.reqArray.splice(0);
        // }
      });
    } else if (this.logedInUserType == "supervisor") {
      this.callingScreen.getSupervisorGrades(localStorage.getItem('userId') , localStorage.getItem("lastShcoolSelectedId")).subscribe((res: any) => {
        // Build flat classes list from grades
        const classes = [] as any[];
        res.forEach(grade => {
          classes.push(...grade.school_classes);
        });
        this.tescherClassList = classes;
        this.delegationInProgressFlag = false;

        // Set grades/originalGrades and aggregate allClasses similar to previous logic
        this.originalGrades = [];
        this.originalGrades = res;
        this.grades = this.originalGrades;
        this.grades.map(grade => {
          this.allClasses.push(...grade.school_classes)
        })
        this.filterSectionsBasedOnRoleGrades(this.originalGrades, this.sections);

        if (this.reload) {
          this.initiatCallingScreen();
        }
      });
    } else {
      this.dataService.getAllGrades().subscribe((res: any) => {
        this.originalGrades = res;
        this.grades = this.originalGrades;
        this.grades.map(grade => {
          this.allClasses.push(...grade.school_classes)
        })
        // this.filteredClasses = this.allClasses;
        this.initiatCallingScreen();
      })
    }
  }

  initiatCallingScreen() {
    this.callingScreen.showCallingScreen(localStorage.getItem('schoolId')).subscribe((data: any) => {
      // console.log('cs api data', data);
      this.refreshFlag = false;
      this.response = [];
      this.loading = false;
      this.filteredData = data.filter(Class => {
        return Class.students.length > 0;
      })
      this.filteringData();
      this.clearFilter();
      this.toggleAnimationWithFilter(false)
      this.refreshFlag = true;
      if (this.soundsArray.length != 0) {
        this.playSound();
      }
    })
  }
  // this method to change every class colums and width debending on number of students in each class
  // callingScreenLayout(Class) {
  //   let csl=Class.students.length;
  //   let percent;
  //   switch (true) {
  //       case csl > 4 && csl <= 8:
  //         this.classItem.col = 6;
  //         percent= 20/ 100;
  //       break;
  //       case csl > 8 && csl <= 12:
  //         this.classItem.col = 4;
  //         percent= 30/ 100;
  //       break;
  //       case csl > 12 && csl <= 16:
  //         this.classItem.col = 3;
  //         percent= 35/ 100;
  //       break;
  //       case csl > 16 && csl <= 24:
  //         this.classItem.col = 2;
  //         percent= 45/ 100;
  //       break;
  //       case csl > 24:
  //         this.classItem.col = 1;
  //         percent= 100/ 100;
  //       break;

  //     default:
  //       this.classItem.col = 12;
  //       percent= 12/ 100;
  //   }
  //   this.classItem.width = this.innerWidth * percent;
  // }
  callingScreenLayout(Class) {
    let csl = Class.students.length;
    let percent;
    switch (true) {
      case this.innerWidth > 260 && this.innerWidth <= 319:
        switch (true) {
          case csl > 4 && csl <= 8:
            this.classItem.col = 6;
            percent = 120 / 100;
            break;
          case csl > 8 && csl <= 12:
            this.classItem.col = 4;
            percent = 140 / 100;
            break;
          case csl > 12 && csl <= 16:
            this.classItem.col = 3;
            percent = 170 / 100;
            break;
          case csl > 16 && csl <= 24:
            this.classItem.col = 2;
            percent = 220 / 100;
            break;
          case csl > 24:
            this.classItem.col = 1;
            percent = 100 / 100;
            break;

          default:
            this.classItem.col = 12;
            percent = 50 / 100;
        }
        this.classItem.width = this.innerWidth * percent;

        break;
      case this.innerWidth > 260 && this.innerWidth <= 319:
        switch (true) {
          case csl > 4 && csl <= 8:
            this.classItem.col = 6;
            percent = 120 / 100;
            break;
          case csl > 8 && csl <= 12:
            this.classItem.col = 4;
            percent = 140 / 100;
            break;
          case csl > 12 && csl <= 16:
            this.classItem.col = 3;
            percent = 170 / 100;
            break;
          case csl > 16 && csl <= 24:
            this.classItem.col = 2;
            percent = 220 / 100;
            break;
          case csl > 24:
            this.classItem.col = 1;
            percent = 100 / 100;
            break;

          default:
            this.classItem.col = 12;
            percent = 50 / 100;
        }
        this.classItem.width = this.innerWidth * percent;

        break;
      case this.innerWidth > 319 && this.innerWidth <= 480:
        switch (true) {
          case csl > 4 && csl <= 8:
            this.classItem.col = 6;
            percent = 80 / 100;
            break;
          case csl > 8 && csl <= 12:
            this.classItem.col = 4;
            percent = 100 / 100;
            break;
          case csl > 12 && csl <= 16:
            this.classItem.col = 3;
            percent = 130 / 100;
            break;
          case csl > 16 && csl <= 24:
            this.classItem.col = 2;
            percent = 200 / 100;
            break;
          case csl > 24:
            this.classItem.col = 1;
            percent = 100 / 100;
            break;

          default:
            this.classItem.col = 12;
            percent = 50 / 100;
        }
        this.classItem.width = this.innerWidth * percent;

        break;
      case this.innerWidth > 480 && this.innerWidth <= 768:
        switch (true) {
          case csl > 4 && csl <= 8:
            this.classItem.col = 6;
            percent = 40 / 100;
            break;
          case csl > 8 && csl <= 12:
            this.classItem.col = 4;
            percent = 70 / 100;
            break;
          case csl > 12 && csl <= 16:
            this.classItem.col = 3;
            percent = 85 / 100;
            break;
          case csl > 16 && csl <= 24:
            this.classItem.col = 2;
            percent = 122 / 100;
            break;
          case csl > 24:
            this.classItem.col = 1;
            percent = 100 / 100;
            break;

          default:
            this.classItem.col = 12;
            percent = 30 / 100;
        }
        this.classItem.width = this.innerWidth * percent;

        break;
      case this.innerWidth > 768 && this.innerWidth <= 1024:
        switch (true) {
          case csl > 4 && csl <= 8:
            this.classItem.col = 6;
            percent = 24 / 100;
            break;
          case csl > 8 && csl <= 12:
            this.classItem.col = 4;
            percent = 46 / 100;
            break;
          case csl > 12 && csl <= 16:
            this.classItem.col = 3;
            percent = 54 / 100;
            break;
          case csl > 16 && csl <= 24:
            this.classItem.col = 2;
            percent = 76 / 100;
            break;
          case csl > 24:
            this.classItem.col = 1;
            percent = 100 / 100;
            break;

          default:
            this.classItem.col = 12;
            percent = 17 / 100;
        }
        this.classItem.width = this.innerWidth * percent;

        break;
      case this.innerWidth > 1024 && this.innerWidth <= 1200:
        switch (true) {
          case csl > 4 && csl <= 8:
            this.classItem.col = 6;
            percent = 22 / 100;
            break;
          case csl > 8 && csl <= 12:
            this.classItem.col = 4;
            percent = 32 / 100;
            break;
          case csl > 12 && csl <= 16:
            this.classItem.col = 3;
            percent = 42 / 100;
            break;
          case csl > 16 && csl <= 24:
            this.classItem.col = 2;
            percent = 62 / 100;
            break;
          case csl > 24:
            this.classItem.col = 1;
            percent = 100 / 100;
            break;

          default:
            this.classItem.col = 12;
            percent = 15 / 100;
        }
        this.classItem.width = this.innerWidth * percent;

        break;
      case this.innerWidth > 1200:
        switch (true) {
          case csl > 4 && csl <= 8:
            this.classItem.col = 6;
            percent = 20 / 100;
            break;
          case csl > 8 && csl <= 12:
            this.classItem.col = 4;
            percent = 30 / 100;
            break;
          case csl > 12 && csl <= 16:
            this.classItem.col = 3;
            percent = 35 / 100;
            break;
          case csl > 16 && csl <= 24:
            this.classItem.col = 2;
            percent = 45 / 100;
            break;
          case csl > 24:
            this.classItem.col = 1;
            percent = 100 / 100;
            break;

          default:
            this.classItem.col = 12;
            percent = 12 / 100;
        }
        this.classItem.width = this.innerWidth * percent;

        break;
    }
  }


  filteringData() {
    if(this.gradeId || this.sectionId){
    this.scrollWidth = 0;
    clearInterval(this.interval);
    this.toggleAnimationWithFilter(false);
    }
    this.response = [];
    console.log('filteredData', this.filteredData);
    console.log('sectionId',this.sectionId);
    // Start with the base data
    let baseArray = this.filteredData;
    // Apply section_id filter if sectionId is defined
    if (this.sectionId) {
    baseArray = baseArray.filter(request => request.section_id == this.sectionId);
    console.log('After section_id filter:', baseArray);
    }
   // Apply grade_id filter if gradeId is defined
    if (this.gradeId) {
    baseArray = baseArray.filter(request => request.grade_id == this.gradeId);
    console.log('After grade_id filter:', baseArray);
    }
  // Apply class_id filter if classId is defined
    if (this.classId) {
    baseArray = baseArray.filter(request => request.id == this.classId);
    console.log('After class_id filter:', baseArray);
    }
  // Assign the final filtered array to this.filterArray
   this.filterArray = baseArray;
   console.log('Final filtered array:', this.filterArray);
    this.getFilteredData(this.filterArray);
    // this.filterArray.length > 0 ? this.getFilteredData(this.filterArray):this.getFilteredData(this.filteredData)
  }

  getFilteredData(array: Array<any>) {
    this.totalRequests = 0;
    this.filteredRequests = 0;
    array.forEach(Class => {
      this.classItem.grade = Class.grade;
      this.classItem.name = Class.name;
      this.classItem.students = Class.students;
      this.callingScreenLayout(Class);
      this.response.push(this.classItem);
      // this.getOwlContainerWidth();
      this.getClassTotalWidth();
      // this.initializeCustomeOptions();
      this.classItem = { name: '', grade: {}, students: [], width: 0, col: 1 };
      // this.totalRequests += Class.students.length;      
    })
    // get total students in old filteredData array => total requests
    this.filteredData.length > 0 ? this.filteredData.forEach(clazz => {
      this.totalRequests += clazz.students.length;
    }) : '';

    /* get total students in filtered array => filtered requests
    and if the filteredData length equals filterArray length that means
    no filter is applied so the filteredRequest should be Zero.
     */
    this.filterArray.length == this.filteredData.length ? this.filteredRequests = 0 :
      this.filterArray.length > 0 ? this.filterArray.forEach(clazz => {
        this.filteredRequests += clazz.students.length;
      }) : '';
  }

  /* this method is to check if the width of all classes combined is bigger than the owl container width or not,
    then toggle owl custom option based on this condition */
  initializeCustomeOptions() {
    if (this.classTotalWidth > this.owlContainerWidth) {
      this.customOptions = {
        loop: true,
        // rewind: true,
        // items:2,   
        // mouseDrag: true,
        // touchDrag: true,
        // pullDrag: true,
        autoWidth: true,
        navSpeed: 700,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        autoplaySpeed: 1500,
        animateIn: true,
        animateOut: true,
        dots: true,
        dotsSpeed: 700,
        slideBy: 'page',
        slideTransition: 'ease-out',

      };

    }
    else {
      this.customOptions = {
        loop: false,
        dots: false,
        // rewind: true,
        autoWidth: true,
      };
    }
  }

  // to get the total width of the owl container div that carries all  cards of classes 
  getOwlContainerWidth() {
    this.owlContainerWidth = $('owl-carousel-o div').width();
  }

  // to get the total width of all cards of classes 
  getClassTotalWidth() {
    // temp is just a temporary container for each class width
    let temp = 0;
    this.response.forEach(clazz => {
      temp += clazz.width;
    });
    this.classTotalWidth = temp;
  }

  onMascotClicked(): void {
    this.amplitudeService.trackEvent('gameWorld-launch', {});
    this.gameModeService.setAvailableClasses(this.allClasses || []);
    this.gameModeService.quickStart(this.classId);
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy() {
    this.reload = false;
    this.activeTab = '';
    this.soundsArray = [];
    clearInterval(this.interval);
    this.interval = null;
    this.callingScreen.cleanup();
    // remove the event listener refrence when component is destroyed to avoid repeated fires of the event
    document.removeEventListener("visibilitychange", this.callingScreenVisibilityChangeHandler);
    // this.realtimeSub$.unsubscribe();
  }

  setStatus(student) {
    // tslint:disable-next-line:no-non-null-assertion
    /* this condition to handle deifferent responces, in some cases students status can be found directly
     in property request_status , and in the other request_status can't be found and student status can 
     be found in requests array (backend problem)
    */
    if (student.request_status) {
      let stat = null;
      stat = student.request_status.name;
      return stat;
    }
    else {
      let stat = null;
      stat = student.requests[0].status[0].name;
      return stat;
    }
  }

  // setIsLate(student) {
  //   //this condition to handle the same backend problem as in setStatus method
  //   if(student.pivot){
  //     let stat = student.pivot.is_late === 1 ? this.translate.instant('calling-screen.late') : null
  //     return stat;
  //   }
  //   else{
  //     let stat = student.requests[0].pivot.is_late === 1 ? this.translate.instant('calling-screen.late') : null
  //     return stat;
  //   }
  // }

  setIsLateClass(student) {
    //to handle with parent status after late status
    // let latestStatus;
    // if (student.request_status) {
    //   latestStatus = student.request_status.name;
    // }
    // else {
    //   latestStatus = student.requests[0].status[0].name;
    // }
    // if(latestStatus != 'with_parent'){
 
    // }
    //this condition to handle the same backend problem as in setStatus method
    if (student.request) {
      let stat = student.request[0].is_late === 1 ? 'late' : null
      return stat;
    }
    else {
      let stat = student.requests[0].is_late === 1 ? 'late' : null
      // let stat = student.requests[0].pivot.is_late === 1 ? 'late' : null
      return stat;
    }
  }


  closeModal() {
    this.showVoiceOnAlert = false;
    this.deliverFlag = false;
  }

  // skipCorruptedFile(){
  //   this.soundsArray.splice(0, 1);
  //   this.playSound(this.soundsArray[0],this.soundsArray[1]);
  // }
  addSoundToPlay(sound) {
  this.soundsArray.push(sound);
    // if (this.soundsArray.length == 1) {
    //   this.playSound();
    // }    
  }
  playingFlag = false;
  playingStatusFlag = false;
  playSound(path = this.soundsArray[0],) {
    // to stop sounds from getting called outside of calling screen 
   if(this.activeTab == 'calling-screen'){
    var audio = new Audio();
    audio.src = path;
    // audio.src = environment.img_url + '/audio/students/mai123-mai Hossam.mp3';
    audio.load();
    audio.addEventListener("ended", (currentTime) => {
      this.playingFlag = false;
      // var audioStatus = new Audio();
      // audioStatus.src = path2;
      // audioStatus.load();
      if (this.soundsArray.length != 0) {
        this.playSound();
        // setTimeout(() => {
        //   this.playSound();
        // }, 1000);
      }
    });
    if (this.playingFlag == false) {
      
      audio.play().catch(err=>{
        
        this.playingFlag = false;
        this.soundsArray.splice(0, 1);
        if(this.soundsArray.length == 0){
          setTimeout(() => {
            this.isRecall = false;
          }, 1000);
        }
        if (this.soundsArray.length != 0) {
          this.playSound();
        }
      });
      this.soundsArray.splice(0, 1);
      if(this.soundsArray.length == 0){
        setTimeout(() => {
          this.isRecall = false;
        }, 1000);
      }
      this.playingFlag = true;
    }
  }
  }

  opendDeliverModal(event) {
    this.callingScreen.getRequestById(event, this.logedInUserType).subscribe(res => {
      this.studentsToDeliver = res['students'];
    }, (err) => {
      if (err) {  
        if(err?.error?.message == 'incorrect id'){
          window.location.reload();
        }
        else{
          this.noDeliver(true)
        }
      }
    }, () => {
      this.deliverFlag = true
    })

  }

  noDeliver(event) {
    if (event == true) {
      this.noDeliverFlag = true

      setTimeout(() => {
        this.noDeliverFlag = false
      }, 3000);
    }
  }

  noDeliverReason(event) {
    switch (event) {
      case 'Admin':
      this.reasonForNoDeliver = this.currLang == 'en' ? 'Admin Does not have access to deliver student':'عذراً! لا يمكن للادمن تسليم الطلاب'
        break;
        case 'pending':
      this.reasonForNoDeliver = this.currLang == 'en' ? 'You are unable to make the student delivery because the request is still pending.':'لا يمكنك تسليم هذا الطالب الآن , طلب النداء لا يزال قيد الانتظار'
        break;
        case 'parent':
      this.reasonForNoDeliver = this.currLang == 'en' ? 'You are unable to deliver the student because the student has already been delivered, we are currently awaiting parent confirmation.':'لا يمكن تسليم هذا الطالب الآن ,الطالب تم تسليمة وفى انتظار تأكيد ولى الأمر'

        break;
        case 'nopermission':
      this.reasonForNoDeliver = this.currLang == 'en' ? 'you are unable to deliver the student because the request has not reached the queue yet.':'يبدو أنك غير قادر على تسليم الطالب لأن الطلب لم يصل إلى قائمة الانتظارالخاصة بك  بعد'
        break;
        case 'observer_mode':
      this.reasonForNoDeliver = this.currLang == 'en' ? 'Observers are not permitted to deliver students':'عذراً! لا يمكن للملاحظين تسليم الطلاب'
        break;

        default:
          this.reasonForNoDeliver = this.currLang == 'en' ? "This student can't be delivered":'لا يمكن تسليم هذا الطالب'
        break;
    }
  }

  deliverStudents() {
    this.studentsToDeliverIds = this.studentsToDeliver.map(student => {
      return student.id
    })
    let body = {
      student_id: this.studentsToDeliverIds
    }
    switch (this.logedInUserType) {
      case "teacher":
        this.callingScreen.teacherDeliver(body).subscribe(res => {

        }, err => {
          this.errorMsgService.setMessage(err.error.message);
        }, () => {
          this.deliverFlag = false;
        });
        break;
      case 'supervisor':
        this.callingScreen.supervisorDeliver(body).subscribe(res => {

        }, err => {
          this.errorMsgService.setMessage(err.error.message);
        }, () => {
          this.deliverFlag = false;
        });
        break;
      // case 'school_admin':
      //   // code block
      //   break;
      default:
        this.deliverFlag = false;
    }
  }

  setGrade(event) {
    console.log('gradeEvent', event);
    this.classId = null;
    this.filteredClasses = [];
    this.className = 'all';
    if(event.value == 'all'){
      this.gradeId = null;
    }
    else {
      this.gradeId = event.value.id;
      this.filteredClasses = this.allClasses.filter(clazz => clazz.grade_id == this.gradeId);
    }  
    if(event?.value?.section_id){
      this.sectionId = event.value.section_id;
      console.log('sections', this.sections);
      let selectedGradeSection = this.sections.find(section => section.id == this.sectionId);
      console.log('selectedGradeSection', selectedGradeSection);
      if(selectedGradeSection){
        this.sectionName = selectedGradeSection;
      }
    }
    else {
      this.sectionName = 'all';
      this.sectionId = null;
    }
    this.filteringData();
  }
  setClass(event) {
    this.classId = event.value.id;
    this.filteringData();
  }

  setSection(event) {
    console.log('sectionEvent', event);
    this.classId = null;
    this.gradeId = null;
    this.gradeName = 'all';
    this.className = 'all';
    this.filteredClasses = [];
    if(event.value == 'all'){
      this.sectionId = null;
      this.grades = this.originalGrades;
    }
    else{
      this.grades = [];
      this.sectionId = event.value.id;
      this.grades = this.originalGrades.filter(grade => grade.section_id == this.sectionId);
    }
    this.filteringData();
  }
  clearFilter() {
    this.gradeId = null;
    this.classId = null;
    this.sectionId = null;
    this.gradeName = 'all';
    this.className = 'all';
    this.sectionName = 'all';
    this.filterArray = this.filteredData;
    this.filteredClasses = [];
    this.grades = this.originalGrades;
    this.filteringData();
    if(this.wasScroll){
      this.toggleAnimationWithFilter(true);
    }
  }

  toggleScroll(){
    this.stopScroll = !this.stopScroll
  }

  switchScroll(){
    this.isScroll = !this.isScroll;
    this.wasScroll = this.isScroll;
    this.toggleAnimationBtn();
    if(this.isScroll){
      this.animateRequests();
    }
    else{
      clearInterval(this.interval);
      this.interval=null;
    }
  }
  
  animateRequests() {
    let time = 3000;
    this.interval=setInterval(() => {
      // to fix browser interval cash when the tab is not focused 
      if(document.hasFocus()){
      var container = $('.requests-container')
      var containerWidth = container.width();
      if ((this.classTotalWidth - containerWidth) < this.scrollWidth || this.scrollWidth < 0) {
        this.direction *= -1;
      }
     /* !this.stopScroll? this.scrollWidth += (100 * this.direction):'';*/
      this.scrollWidth += (100 * this.direction);      
      container.animate({ scrollLeft: `${this.scrollWidth}` },
        {
          duration: time,
          complete: function () {
          }
        });
      }
    }, time);

  }

  toggleAnimationBtn(){
    let button = document.querySelector('.toggle-scroll');
    let onOffIcon = document.querySelector('.on-off');
    this.isScroll ? button.classList.add('outline-off') : button.classList.remove('outline-off');
    this.isScroll ? onOffIcon.classList.add('green') : onOffIcon.classList.remove('green');
  }

  toggleAnimationWithFilter(flag:boolean){
    // wasScroll to toggle scroll with filter and the initial state of the scroll 
    this.isScroll = flag ? this.wasScroll : flag;
    this.toggleAnimationBtn();
    if(flag && this.wasScroll){
      this.animateRequests();
    }
    else{
      clearInterval(this.interval)
    }
  }
  recallSounds(){
    this.recallSoundsArray = [];
    if(this.soundsArray.length == 0 && this.response.length > 0){
    this.isRecall = !this.isRecall;
        let statusCalling = localStorage.getItem('statusCalling');     
        this.response.forEach(clazz=>{
          clazz.students.forEach(student => {
            this.recallSoundsArray.push(student.audio_file_path);
            this.recallSoundsArray.push(student.request ? student.request[0].is_late ? student.request[0].status_file_url[`${statusCalling}`] : student.request_status.status_file_url[`${statusCalling}`] :
             student.requests[0].is_late ? student.requests[0].status_file_url[`${statusCalling}`] : student.request_status.status_file_url[`${statusCalling}`]);
          });
        })
        this.recallCount = this.recallSoundsArray.length;
        this.soundsArray = [...this.soundsArray , ...this.recallSoundsArray]
          this.playSound();
      }
  }

  toggleRecallTip(){
  if(this.response?.length == 0){
    this.toggleRecallTipFlag = true;
    this.recallTip = 'calling-screen.recall-tip-no-requests';
  }
  if(this.soundsArray?.length > 0){
    this.toggleRecallTipFlag = true;
    this.recallTip = 'calling-screen.recall-tip-sounds-on';
  }
  }

  filterSectionsBasedOnRoleGrades(grades, sections) {
    // Step 1: Extract section_ids from grades array, filtering out null values
    const sectionIds = new Set(grades
      .map(grade => grade.section_id)
      .filter(id => id !== null)
    );
  
    // Step 2: Filter sections array
    const filteredSections = sections.length > 0 
      ? sections.filter(section => sectionIds.has(section.id))
      : [];
  
    // Assign filteredSections to this.sections
    this.sections = filteredSections;
  }

  /**
 * Monitors when the browser tab becomes hidden or visible.
 *
 * Behavior:
 * - When the tab is hidden, it disables voice alerts (`showVoiceOnAlert = false`).
 * - When the tab becomes visible again, it checks if voice calling is enabled in localStorage.
 *   If enabled (`localStorage.getItem('voiceCalling') === 'true'`), it re-enables voice alerts.
 *
 * This ensures voice alerts are only active when the tab is in focus and voice calling is turned on.
 */
checkVisibilityChange(): void {
  this.callingScreenVisibilityChangeHandler = () => {
    const isVoiceCallingEnabled = localStorage.getItem('voiceCalling') == 'true';
    this.showVoiceOnAlert = !document.hidden && isVoiceCallingEnabled;
    // console.log('[CS] Visibility change:', this.showVoiceOnAlert);
  };
  // add the event listener refrence 
  document.addEventListener("visibilitychange", this.callingScreenVisibilityChangeHandler);
}
}

